// extracted by mini-css-extract-plugin
export default {"image":"h2-z","loaded":"i2-z"};